import Skeleton from '@components/v2/ui/Skeleton/Skeleton';
import { Box } from '@mui/material';
import BannerCarousel from './components/BannerCarousel/BannerCarousel';
import { BANNER_ASPECT_RATIO } from './components/BannerCarousel/bannerCarousel.consts';
import { useStoreBanners } from './hooks/useStoreBanners';
import { StoreBannersTestIds } from './storeBanners.testIds';

const StoreBanners = () => {
  const { slides, isLoading } = useStoreBanners();

  if (!isLoading && slides.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      {isLoading ? (
        <Skeleton
          variant="rounded"
          sx={(theme) => ({
            width: '100%',
            aspectRatio: BANNER_ASPECT_RATIO,
            borderRadius: `${theme.shape.borderRadius2xl}px`,
          })}
        />
      ) : (
        <BannerCarousel slides={slides} testId={StoreBannersTestIds.CAROUSEL} />
      )}
    </Box>
  );
};

export default StoreBanners;
